export default __webpack_public_path__ + "static/media/Flag_of_Panama.0c61d880.svg";